import { Link, Head, router } from '@inertiajs/react';
import { PageProps } from '@/types';


import Specialistdoctors from './Welcome/Specialistdoctors/Specialistdoctors';
import { useTranslation } from 'react-i18next';

import Blogs from './Welcome/Blogs/Blogs';
import Possibilty from './Welcome/Possibilty/Possibilty';

import MapEmbed from '@/Components/MapEmbed';
import Offers from './Welcome/Offers/Offers';
import Insurance from './Welcome/InsurancePartner/Insurance';
import PatientExperince from './Welcome/PatientExperince/PatientExperince';

import AboutUs from './Welcome/AboutUs/AboutUs';
import Faqs from './Welcome/Faqs/Faqs';
import OurNews from './Welcome/OurNews/OurNews';
import MainDepartment from './Welcome/Departments/MainDepartment';
import Sliders from './Welcome/Sliders/Sliders';
import OurHistory from './Welcome/OurHistory/OurHistory';
import { useEffect, useState } from 'react';
import LoadingPage from '@/Components/LoadingPage/LoadingPage';

export default function Welcome({ slides, insurance, departments, blogs, ournews, aboutus, posibility, faqs, humanbodies, humanbodiestow, offers }: PageProps<{ slides: any, departments: any, blogs: any, insurance: any, ournews: any, aboutus: any, posibility: any, faqs: any, humanbodies: any, humanbodiestow: any, offers: any }>) {
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        setTimeout(() => {
            setLoading(false)
        }, 2000);
    } , [])


        return ( loading ?
            (<LoadingPage />)
            :
            (  <>
                <Head title={t('welcome.title')} />

                {/* sliders */}
                <Sliders slides={slides} />

                {/* search doctor */}
                <Specialistdoctors departments={departments} />

                {/* our possibilty */}
                <Possibilty posibility={posibility} />


                {/* our department */}
                <MainDepartment humanbodies={humanbodies} departments={humanbodiestow} />


                {/* about us */}
                <AboutUs aboutus={aboutus} />

                {/* our history */}
                <OurHistory />

                {/* our news */}
                <OurNews news={ournews} />

                {/* our offers */}
                <Offers offers={offers} />

                {/* insurance partner */}
                <Insurance insurance={insurance} />

                {/* Patient Experince */}
                <PatientExperince />

                {/* our blogs */}
                <Blogs blogs={blogs} />


                {/* our Faqs */}
                <Faqs faqs={faqs} />


                {/* map embed */}
                <div className='m-5'>
                    <MapEmbed />
                </div>
            </>)

        );

}
